angular.module('TetherApp').directive('tetherSubmit', function () {
    return {
        restrict: 'E',
        templateUrl: '/html/form/tetherSubmit.html'
    }
});
